import { WorkplaceCompressedDtoTypeEnum } from '@jooxter/api';

export const WORKPLACES_TYPES = [
  WorkplaceCompressedDtoTypeEnum.Office,
  WorkplaceCompressedDtoTypeEnum.WorkFromHome,
  WorkplaceCompressedDtoTypeEnum.Off,
  WorkplaceCompressedDtoTypeEnum.Mission,
  WorkplaceCompressedDtoTypeEnum.Unknown,
];
